<script>
import { useModalStore } from '../../../stores/modal';
import { mapState, mapActions } from 'pinia';

export default {
	props: {
		popupId: {
			type: String,
			required: true
		},
		popupTitle: {
			type: String,
			default: ''
		}
	},

	data() {
		return {
			modalStore: null
		};
	},

	computed: {
		...mapState(useModalStore, {
			isActive: 'isModalActive',
			getConfig: 'config'
		}),
		
		modalClass() {
			return [
				this.getConfig('classModal'),
				{[this.getConfig('classModalActive')]: this.isActive(this.popupId)}
			];
		}
	},

	mounted() {
		this.registerModal(this.popupId);
	},

	beforeUnmount() {
		this.unregisterModal(this.popupId);
	},

	methods: {
		...mapActions(useModalStore, [
			'registerModal',
			'unregisterModal',
			'openModal',
			'closeModal'
		]),
		
		open() {
			this.openModal(this.popupId);
		},

		close() {
			if (this.isActive) {
				this.closeModal();
			}
		}
	}
};
</script>

<template>
	<div
		:id="popupId"
		class="modal-window"
		:class="modalClass"
		@keydown.esc="close"
	>
		<div class="modal-window__body">
			<div class="modal-window__scroll">
				<div class="modal-window__content">
					<div class="modal-window__header">
						<div class="modal-window__title h3">{{ popupTitle }}</div>
						<button
							class="button button--sm button--white--gray"
							type="button"
							aria-label="close"
							@click="close"
						>
							<i class="icon icon-close"></i>
						</button>
					</div>
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>
